const loadRecaptcha = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (window.grecaptcha) {
            window.grecaptcha.ready(() => resolve());
            return;
        }

        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${process.env['VITE_RECAPTCHA_SITE_KEY']}`;
        script.async = true;

        script.onload = () => {
            window.grecaptcha.ready(() => resolve());
        };

        script.onerror = () => {
            reject(new Error('Failed to load reCAPTCHA'));
        };

        document.head.appendChild(script);
    });
};

export const getRecaptchaToken = async (): Promise<string> => {
    await loadRecaptcha();

    if (!window.grecaptcha || typeof window.grecaptcha.execute !== 'function') {
        throw new Error('reCAPTCHA is not properly initialized');
    }

    return new Promise((resolve, reject) => {
        window.grecaptcha
            .execute(process.env['VITE_RECAPTCHA_SITE_KEY'] || '', {
                action: 'submit',
            })
            .then(resolve)
            .catch(reject);
    });
};
